import { routerRedux } from "dva/router";
import api from "@/service";
import { Toast } from "antd-mobile";
const {
    adminRegister,
    currencyCountOfAdmin,
    funcGroupList,
    currencyRenewSurlpusCount,
    currencyTradeSurlpusCount,
    userCurrencyCount
} = api;
export default {
    namespace: "app",
    state: {
        name: "app",
        selectGroups: [],
        currencyTotalCount: 0,
        currencyUsedCount: 0,
        funcGroupList: [],
        renewSurlpusCount: 0,
        permanentCurrencyCount: 0,
        permanentCurrencyCount2: 0,
    },
    subscriptions: {
        setup({ dispatch, history }) {
            history.listen(location => {
                console.log(location);
                if (
                    location.pathname == "/login" &&
                    sessionStorage.getItem("loginMsg")
                ) {
                    dispatch({
                        type: "menu",
                    });
                } else {
                    if (
                        location.pathname != "/register" &&
                        location.pathname != "/login" &&
                        !sessionStorage.getItem("loginMsg")
                    ) {
                        dispatch({
                            type: "login",
                        });
                    }
                }
            });
        },
    },
    effects: {
        *menu({ payload }, { put }) {
            yield put(routerRedux.push("/menu"));
        },
        *login({ payload }, { put }) {
            yield put(routerRedux.push("/login"));
        },
        *register({ payload }, { call, put }) {
            let data = yield call(adminRegister, payload);
            console.log(data);
            if (data.status == 200) {
                Toast.success(
                    `注册成功，您手机号${payload.mobile}的登录密码为${data.data}`,
                    3,
                );
            } else {
                Toast.fail(`注册失败，${data.message}`, 3);
            }
        },
        //获取管理员虚拟币信息
        *getCurrencyCountOfAdmin({ payload }, { call, put }) {
            let datas = yield call(currencyCountOfAdmin, payload);
            const { data } = datas
            if (datas.status == 200) {
                if (data) {
                    let totalCount = 0;
                    let usedCount = 0;
                    if (data[payload[0]]) {
                        totalCount = data[payload[0]].totalCount;
                        usedCount = data[payload[0]].usedCount;
                    }
                    yield put({
                        type: "updateState",
                        payload: {
                            currencyTotalCount: totalCount,
                            currencyUsedCount: usedCount,
                        },
                    });
                }
            } else {
                Toast.fail(`${datas.message}`, 3);
            }
        },
        *getFuncGroupList({ payload }, { call, put }) {
            let data = yield call(funcGroupList, {
                pageNo: 1,
                pageSize: 1000,
            });
            console.log(data);
            yield put({
                type: "updateState",
                payload: {
                    funcGroupList: data.data,
                },
            });
        },
        // 查询终身币
        *getPermanentCount({ payload }, { put, call }) {
            let datas = yield call(userCurrencyCount, payload)
            const { data } = datas
            yield put({
            type: 'updateState',
            payload: {
                permanentCurrencyCount: data,
            },
            })
        },
        // 查询目标管理员终身币 
        *getPermanentCountById({ payload }, { put, call }) {
            let datas = yield call(userCurrencyCount, payload)
            const { data } = datas
            yield put({
            type: 'updateState',
            payload: {
                permanentCurrencyCount2: data,
            },
            })
        },

        //获取管理员续费币信息
        *getCurrencyRenewSurlpusCount({ payload }, { call, put }) {
            let datas = yield call(currencyRenewSurlpusCount, payload);
            const { data } = datas
            if (datas.status == 200) {
                yield put({
                    type: "updateState",
                    payload: {
                        renewSurlpusCount: data,
                    },
                });
            }
        },
        //获取管理员行业币信息
        *getCurrencyTradeSurlpusCount({ payload }, { call, put }) {
            let datas = yield call(currencyTradeSurlpusCount, payload);
            if (datas.status == 200) {
                return datas.data;
            } else {
                Toast.fail(`${datas.message}`, 3);
            }
        },
    },
    reducers: {
        updateState(state, { payload }) {
            return {
                ...state,
                ...payload,
            };
        },
        //保存选择的群组
        selectGroupList(state, { selectGroups }) {
            console.log(selectGroups);
            return {
                ...state,
                selectGroups: selectGroups.selectGroups,
            };
        },
        deleteSelectGroup(state, { gid }) {
            let groupArr = [...state.selectGroups];
            groupArr.splice(groupArr.map(item => item.gid).indexOf(gid), 1);
            console.log(groupArr);
            return {
                ...state,
                selectGroups: groupArr,
            };
        },
        emptySelectGroup(state) {
            return {
                ...state,
                selectGroups: [],
            };
        },
    },
};
